import * as ResultsProductsAndInventions from './resultsProductsAndInventions.js';
export default ResultsProductsAndInventions;
